import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteHarness } from '@/lib/api/generated/api';

import { toHarnessError } from '../errors';
import { harnessKeys } from '../queryKeys';

/**
 * Delete an Harness outright.
 *
 * Refused with `HarnessHasDependentProfilesError` while any LLM Profile
 * still references it (FR-009), or `HarnessIsDefaultError` while it is the
 * default (FR-009b) — the caller keeps its dialog open and renders the
 * mapped refusal rather than treating every failure the same way.
 */
export function useDeleteHarness() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string): Promise<void> => {
      const response = await deleteHarness(id);
      if (response.status === 204) return;
      throw toHarnessError(response.status, response.data);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: harnessKeys.all() });
    },
  });
}
